module.exports = __webpack_public_path__ + "img/test_types.ae4266a8.svg";